import React from 'react';
import './NoResult.scss';

const NoResult = props => {
  const {text} = props;
  return (
    <div className="NoResult" data-testid="NoResult">
      <div className="gcap-search-results">
        <div className="gcap-search-results--error">
          <div className="gcap-glyph">
            <i className="search_error_result_icon" aria-hidden="true"></i>
          </div>
          <h3 className="gcap-search-results--error-message headline-bold-fs2">{text}</h3>
        </div>
      </div>
    </div>
  )
};

export default NoResult;
